import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import PlayerHeroComponent from './js/player-hero.component';

ComponentsFactory.getInstance().define('player-hero', PlayerHeroComponent);